import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Theme, Grid, Link } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import ClearIcon from '@material-ui/icons/Clear'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'
import clsx from 'clsx'
import DeleteAllDialog from '../DeleteDialog'
import { configContext } from '../../products/DnaPlates/DnaPlates'
import {
  Specifications,
  PlateProduct,
  CountryCodes,
  USExportCountriesListFor384Well,
  minimumWellsExecptionCountries,
  australianCountries,
} from '../../products/DnaPlates/enum'

const useStyles = makeStyles((theme: Theme) => ({
  dialog: {
    minHeight: theme.spacing(80),
    overflow: 'hidden',
  },
  buttonWrapper: {
    justifyContent: 'flex-start',
    padding: theme.spacing(2, 6),
  },
  clearButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  table: {
    minWidth: theme.spacing(225),
  },
  title: {
    backgroundColor: theme.palette.background.grey,
  },
  rootRow: {
    color: theme.palette.grey[500],
    fontWeight: theme.typography.fontWeightMedium,
  },
  deleteAll: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.primary.main,
    margin: theme.spacing(0),
    padding: theme.spacing(0),
    '&:hover': {
      backgroundColor: 'inherit',
      color: theme.palette.primary.dark,
    },
  },
  delPopup: {
    height: theme.spacing(0),
  },
  labelRoot: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.grey[500],
  },
  alignName: {
    paddingLeft: theme.spacing(1),
  },
  activeLabel: {
    color: theme.palette.primary.main,
  },
  deleteIcon: {
    fontSize: theme.typography.pxToRem(22),
    color: theme.palette.grey[400],
  },
  errorRow: {
    '& th': {
      borderLeft: `${theme.spacing(2)}px solid ${theme.palette.rich.red}`,
    },
  },
}))

const ViewAllDialogForPlate = (props) => {
  const { dialogOpen, setDialogOpen, viewAllItems, onDelete } = props
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false)
  const [delItem, setDelItem] = React.useState()
  const [delType, setDelType] = React.useState('')
  const { state, dispatch } = React.useContext(configContext)
  const [index, setIndex] = React.useState(state.currentPlateIndex)
  const data = viewAllItems

  const handleClose = () => {
    setDialogOpen(false)
  }
  const handleClickonPlateName = (index) => {
    setIndex(index)
    handleClose()
  }
  React.useEffect(() => {
    state.currentPlateIndex = index
    dispatch({
      type: 'UPDATE_CURRENT_PLATE_INDEX',
      data: state.currentPlateIndex,
    })
    // TODO: need a test before we refactor these dependencies
  }, [index])
  const handleDelete = (item, type) => {
    setDeleteDialogOpen(true)
    setDelItem(item)
    setDelType(type)
  }
  const deleteAll = (type) => {
    setDeleteDialogOpen(true)
    setDelItem(data)
    setDelType(type)
  }

  const displayErrorBar = (item) => {
    let errorCount = false
    if (
      item.plateNameError.length !== 0 ||
      item.researcherNameError.length !== 0
    ) {
      errorCount = true
    }

    if (item.productType === PlateProduct.DuplexPlate) {
      item.biTubeWellList.forEach((duplexwell) => {
        if (duplexwell.listError.length !== 0) {
          errorCount = true
        }
      })
    } else {
      item.wellList.forEach((well) => {
        if (well.listError.length !== 0) {
          errorCount = true
        }
      })
    }

    if (state.minimumWellsError && state.sessionData[0].isOverridden !== true) {
      if (item.productType === PlateProduct.DuplexPlate) {
        if (item.biTubeWellList.length < 24) {
          errorCount = true
        }
      } else {
        if (
          !(
            item.wellType === PlateProduct.wellType &&
            USExportCountriesListFor384Well.includes(item.countryCode)
          ) ||
          minimumWellsExecptionCountries.includes(item.countryCode)
        ) {
          if (
            item.countryCode === CountryCodes.JP ||
            australianCountries.includes(item.countryCode)
          ) {
            if (
              (item.plateType === Specifications.STANDARD &&
                item.wellList.length < 48) ||
              (item.plateType === Specifications.MIXED &&
                item.wellList.length < 96)
            ) {
              errorCount = true
            }
          } else {
            if (
              (item.plateType === Specifications.STANDARD &&
                item.wellList.length < 24) ||
              (item.plateType === Specifications.MIXED &&
                item.wellList.length < 48)
            ) {
              errorCount = true
            }
          }
        }
      }
    }

    return errorCount
  }
  const classes = useStyles()
  const renderData = () => {
    const result: any[] = []
    data.map((row, index) =>
      result.push(
        <TableRow
          key={index}
          className={displayErrorBar(row) ? classes.errorRow : ''}
        >
          <TableCell component="th" scope="row">
            <Link
              href="#"
              underline="hover"
              className={clsx(
                classes.labelRoot && classes.activeLabel,
                !displayErrorBar(row) && classes.alignName
              )}
              onClick={() => handleClickonPlateName(index)}
            >
              {row.plateName.length !== 0 ? row.plateName : '--'}
            </Link>
          </TableCell>
          {row.plateType === Specifications.STANDARD ? (
            <TableCell align="left">
              {row.wellType.length !== 0 ? row.wellType : '--'}
              <FormattedMessage {...messages.CONF_DNAPLATE_VIEWALL_WELL} />
              {row.channelType.length !== 0 ? row.channelType : '--'}
              <FormattedMessage
                {...messages.CONF_DNAPLATE_VIEWALL_CHANNEL_TEXT}
              />
            </TableCell>
          ) : (
            <TableCell align="left">
              {row.wellType.length !== 0 ? row.wellType : '--'}
              <FormattedMessage {...messages.CONF_DNAPLATE_VIEWALL_WELL} />
              {row.channelType.length !== 0 ? row.channelType : '--'}
              <FormattedMessage
                {...messages.CONF_DNAPLATE_VIEWALL_CHANNEL_MIXED_TEXT}
              />
            </TableCell>
          )}
          {row.productType === PlateProduct.DuplexPlate ? (
            <TableCell align="center">
              {row.biTubeWellList.length !== 0
                ? row.biTubeWellList.length
                : '--'}
            </TableCell>
          ) : (
            <TableCell align="center">
              {row.wellList.length !== 0 ? row.wellList.length : '--'}
            </TableCell>
          )}
          <TableCell align="center">
            {row.researcher !== '' ? row.researcher : '--'}
          </TableCell>
          <TableCell align="left">
            <IconButton
              aria-label="delete"
              onClick={() => {
                handleDelete(row, 'Selected')
              }}
            >
              <DeleteIcon className={classes.deleteIcon} />
            </IconButton>
          </TableCell>
        </TableRow>
      )
    )

    return result
  }
  return (
    <Dialog
      onClose={handleClose}
      aria-label="Are you sure you want to clear items?"
      open={dialogOpen}
      maxWidth="md"
      classes={{ paperScrollPaper: classes.dialog }}
    >
      <DialogTitle className={classes.title}>
        {' '}
        <FormattedMessage {...messages.CONF_MY_PLATES_SIDE_BAR} />:{' '}
        <FormattedMessage {...messages.CONF_VIEW_ALL_SIDE_BAR} />
      </DialogTitle>
      <IconButton
        className={classes.clearButton}
        color="primary"
        onClick={handleClose}
      >
        <ClearIcon />
      </IconButton>
      <DialogContent>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell align="left" className={classes.rootRow}>
                <FormattedMessage
                  {...messages.CONF_DNAPLATE_VIEWALL_PLATENAME_TEXT}
                />
              </TableCell>
              <TableCell align="left" className={classes.rootRow}>
                <FormattedMessage {...messages.CONF_DNAPLATES_PLATE_TYPE} />
              </TableCell>
              <TableCell align="center" className={classes.rootRow}>
                <FormattedMessage
                  {...messages.CONF_DNAPLATE_VIEWALL_OLIGOS_TEXT}
                />
              </TableCell>
              <TableCell align="center" className={classes.rootRow}>
                <FormattedMessage
                  {...messages.CONF_DNAPLATE_VIEWALL_RESEARCH_NAME_TEXT}
                />
              </TableCell>
              <TableCell align="left" className={classes.rootRow}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderData()}</TableBody>
        </Table>
      </DialogContent>
      <DialogActions className={classes.buttonWrapper}>
        <Grid container spacing={8}>
          <Grid item sm={10}>
            <div>
              <Button color="primary" variant="contained" onClick={handleClose}>
                <FormattedMessage {...messages.CONF_CLOSE_BUTTON} />
              </Button>
            </div>
          </Grid>
          <Grid item sm={2}>
            <div>
              <Button
                className={classes.deleteAll}
                onClick={() => {
                  deleteAll('All')
                }}
              >
                <FormattedMessage
                  {...messages.CONF_DELETE_ALL_BUTTON_TEXT_DNA_PLATES}
                />
              </Button>
            </div>
          </Grid>
        </Grid>
      </DialogActions>
      <div className={classes.delPopup}>
        <DeleteAllDialog
          dialogOpen={deleteDialogOpen}
          setDialogOpen={setDeleteDialogOpen}
          selectedItem={delItem}
          type={delType}
          onDelete={onDelete}
        />
      </div>
    </Dialog>
  )
}

export default ViewAllDialogForPlate
